const o = "#ffffff", r = "2", d = "4", n = "9999", t = "8", c = "16", s = "32", a = "768", C = "992", e = "1232";
export {
  e as CdrBreakpointLg,
  C as CdrBreakpointMd,
  a as CdrBreakpointSm,
  o as CdrColorBackgroundPrimary,
  n as CdrRadiusRound,
  r as CdrRadiusSoft,
  d as CdrRadiusSofter,
  t as CdrSpaceHalfX,
  c as CdrSpaceOneX,
  s as CdrSpaceTwoX
};
